import { Chip, useTheme } from "@mui/material";

const getColors = (value, priorityColors) => {
  switch (value) {
    case "High":
      return {
        backgroundColor: priorityColors.high,
        color: "error.dark",
      };
    case "Medium":
      return {
        backgroundColor: priorityColors.medium,
        color: "warning.dark",
      };
    case "Low":
      return {
        backgroundColor: priorityColors.low,
        color: "success.dark",
      };
    default:
      return {
        backgroundColor: priorityColors.default,
        color: "text.secondary",
      };
  }
};

const PriorityChip = ({ priority, size = "small" }) => {
  const theme = useTheme();

  if (!priority) {
    return <></>;
  }

  const colors = getColors(priority, theme.brand.priority);

  return (
    <Chip label={priority} size={size} sx={{ fontWeight: 500, ...colors }} />
  );
};

export default PriorityChip;
